import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function CustomCursor() {
  const [enabled, setEnabled] = useState(false);
  const [hovering, setHovering] = useState(false);
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const ringX = useSpring(x, { stiffness: 350, damping: 32, mass: 0.6 });
  const ringY = useSpring(y, { stiffness: 350, damping: 32, mass: 0.6 });

  useEffect(() => {
    const mq = window.matchMedia("(pointer: fine)");
    if (!mq.matches) return;
    setEnabled(true);
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
    };
    const over = (e) => setHovering(!!e.target.closest("a, button, input, select, textarea, [data-cursor]"));
    window.addEventListener("mousemove", move, { passive: true });
    window.addEventListener("mouseover", over, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, [x, y]);

  if (!enabled) return null;

  return (
    <>
      <motion.div
        className="fixed top-0 left-0 z-[150] w-1.5 h-1.5 rounded-full bg-[#FF5A00] pointer-events-none"
        style={{ x, y, translateX: "-50%", translateY: "-50%" }}
        data-testid="cursor-dot"
      />
      <motion.div
        className="fixed top-0 left-0 z-[150] rounded-full border border-[#FF5A00]/70 pointer-events-none"
        style={{ x: ringX, y: ringY, translateX: "-50%", translateY: "-50%" }}
        animate={{
          width: hovering ? 52 : 30,
          height: hovering ? 52 : 30,
          opacity: hovering ? 1 : 0.55,
          backgroundColor: hovering ? "rgba(255,90,0,0.08)" : "rgba(255,90,0,0)",
        }}
        transition={{ duration: 0.25 }}
        data-testid="cursor-ring"
      />
    </>
  );
}
